<!--
 FieldCustom provides flexibilty to pass in any arbitruary component to meet UI requirments)
-->
<template>
  <div
    class="FieldCustom"
    :style="modelRow.field.cssStyle"
    data-testid="custom-field-component"
  >
    <component
      v-if="showButton"
      :is="modelRow.field.component"
      :model-row="modelRow"
      v-bind="modelRow.field.componentProps"
      @click="
        additionalDocsRelated
          ? (displayUploadEnableDialog = true)
          : (displayDownloadDialog = true)
      "
      data-testid="custom-field-component-AdsButton"
    />
    <component
      v-else-if="modelRow.field.component !== 'AdsButton'"
      :is="modelRow.field.component"
      :model-row="modelRow"
      v-bind="modelRow.field.componentProps"
      data-testid="custom-field-component-non-AdsButton"
    />
    <DocsUploadToggleStatusModal
      v-if="
        modelRow.field.component === 'AdsButton' && displayUploadEnableDialog
      "
      :type="modelRow.field.category"
      @close="displayUploadEnableDialog = false"
    />
    <DownloadDocumentsModal
      v-if="modelRow.field.component === 'AdsButton' && displayDownloadDialog"
      :applications="applicationInfo"
      :school-code="schoolCode"
      :application-type="APPLICATION_TYPE.LOCAL_AREA"
      :skip-download-app="true"
      @close="displayDownloadDialog = false"
    />
  </div>
</template>

<script>
import { APPLICATION_TYPE, FILE_STATUSES } from '@/constants'
import { AdsButton } from '@nswdoe/doe-ui-core'
import fieldHelperMixin from '@/helpers/fieldHelperMixin'
import InfoPanel from '@/components/application/InfoPanel'
import SimpleHr from '@/components/application/SimpleHr'
import SimpleParagraphs from '@/components/application/SimpleParagraphs'
import MessageWithAction from '@/components/app/MessageWithAction.vue'
import DownloadDocumentsModal from '@/components/applicationList/DownloadDocumentsModal.vue'
import DocsUploadToggleStatusModal from '@/components/application/DocsUploadToggleStatusModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'FieldCustom',
  props: {
    modelRow: {
      type: Object
    }
  },
  mixins: [fieldHelperMixin],
  components: {
    InfoPanel,
    SimpleHr,
    SimpleParagraphs,
    MessageWithAction,
    AdsButton,
    DownloadDocumentsModal,
    DocsUploadToggleStatusModal
  },
  data() {
    return {
      displayDownloadDialog: false,
      displayUploadEnableDialog: false,
      APPLICATION_TYPE
    }
  },
  computed: {
    ...mapGetters(['currentStream']),
    additionalDocsRelated() {
      return ['enable', 'disable'].includes(this.modelRow.field?.category)
    },
    containsSafeSupportingDocuments() {
      const supportingDocuments = Object.values(
        this.application.supportingDocuments
      )
        .flat()
        .filter((doc) => doc.status === FILE_STATUSES.SAFE)
        .map((doc) => doc.objectKey)
      return supportingDocuments.length > 1
    },
    canView() {
      return this.$store.state.userGroup === this.modelRow.field.canView
    },
    application() {
      return this.$store.getters.application
    },
    schoolCode() {
      return this.application.schoolCode
    },
    applicationInfo() {
      return [
        {
          applicationID: this.application.applicationID,
          studentFirstName: this.application.student.firstName,
          studentFamilyName: this.application.student.familyName,
          supportingDocuments: this.application.supportingDocuments,
          isDigitizeEOIConsiderationDocUploaded:
            this.application.isDigitizeEOIConsiderationDocUploaded
        }
      ]
    },
    showButton() {
      let shouldShowButton = false
      if (this.modelRow.field.component !== 'AdsButton') {
        shouldShowButton = false
      } else if (this.additionalDocsRelated) {
        shouldShowButton = true
      } else if (this.canView && this.containsSafeSupportingDocuments) {
        shouldShowButton = true
      }
      return shouldShowButton
    }
  }
}
</script>

<style scoped lang="scss">
.FieldCustom {
  padding: $content-padding;
}
#app.v-application .v-btn--outlined.red--text {
  border-color: $color-red;
}
</style>
